module.exports = __webpack_public_path__ + "assets/img/e8cf430229f8ddaa38398da36a19d28f.svg";